var T = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var i = (e, t, s) => t in e ? T(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, r = (e, t) => {
  for (var s in t || (t = {}))
    y.call(t, s) && i(e, s, t[s]);
  if (o)
    for (var s of o(t))
      c.call(t, s) && i(e, s, t[s]);
  return e;
};
var m = (e, t) => {
  var s = {};
  for (var a in e)
    y.call(e, a) && t.indexOf(a) < 0 && (s[a] = e[a]);
  if (e != null && o)
    for (var a of o(e))
      t.indexOf(a) < 0 && c.call(e, a) && (s[a] = e[a]);
  return s;
};
import { jsxs as A, Fragment as B, jsx as d } from "react/jsx-runtime";
import { e as D, g as E, u as L, n as b, o as q, I as M, B as O, q as W } from "./factory--gUH4vxz.js";
import "react";
import { p as X } from "./polymorphic-factory-B5K75Ixh.js";
const Y = {
  gap: { type: "spacing", property: "gap" },
  rowGap: { type: "spacing", property: "rowGap" },
  columnGap: { type: "spacing", property: "columnGap" },
  align: { type: "identity", property: "alignItems" },
  justify: { type: "identity", property: "justifyContent" },
  wrap: { type: "identity", property: "flexWrap" },
  direction: { type: "identity", property: "flexDirection" }
};
var u = { root: "m_8bffd616" };
const $ = {}, f = X((e, t) => {
  const s = D("Flex", $, e), l = s, {
    classNames: a,
    className: g,
    style: x,
    styles: S,
    unstyled: F,
    vars: P,
    gap: h,
    rowGap: G,
    columnGap: N,
    align: j,
    justify: w,
    wrap: v,
    direction: _
  } = l, C = m(l, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "gap",
    "rowGap",
    "columnGap",
    "align",
    "justify",
    "wrap",
    "direction"
  ]), I = E({
    name: "Flex",
    classes: u,
    props: s,
    className: g,
    style: x,
    classNames: a,
    styles: S,
    unstyled: F,
    vars: P
  }), R = L(), n = b(), p = q({
    styleProps: { gap: h, rowGap: G, columnGap: N, align: j, justify: w, wrap: v, direction: _ },
    theme: R,
    data: Y
  });
  return /* @__PURE__ */ A(B, { children: [
    p.hasResponsiveStyles && /* @__PURE__ */ d(
      M,
      {
        selector: `.${n}`,
        styles: p.styles,
        media: p.media
      }
    ),
    /* @__PURE__ */ d(
      O,
      r(r({
        ref: t
      }, I("root", {
        className: n,
        style: W(p.inlineStyles)
      })), C)
    )
  ] });
});
f.classes = u;
f.displayName = "@mantine/core/Flex";
export {
  f as F
};
